<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Consulta de notas fiscalis eletrônicas recebidas.</span>
                <br />
                <span class="navigation">Relatório > Consulta notas recebidas</span>
              </h4>
            </div>
          </div>
        </div>

        <div class="card-body">
          <error-list :erros="erros" />

          <div class="row">
            <div class="col-md-2 col-lg-2 mb-1">
              <label for="compIni">Competência Inicial: *</label>
            </div>
            <div class="col-md-2 col-lg-2 mb-1">
              <label for="compFim">Competência Final: *</label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <InputMask v-model="compIni" id="compIni" mask="9999/99" placeholder="Competência Inicial" />
              </span>
            </div>

            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <InputMask v-model="compFim" id="compFim" mask="9999/99" placeholder="Competência Final" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-3">
              <label for="tipoTomador">Filtro por Prestador?:</label>
              <span class="p-fluid"
                ><br />
                <Checkbox v-model="checkPrestador" :binary="true" />
              </span>
            </div>
          </div>
          <template v-if="checkPrestador == true">
            <div class="row">
              <div class="col-md-4 mb-3">
                <label for="tipoTomador">Tipo:</label>
                <span class="p-fluid">
                  <Dropdown
                    @change="selecaoTipo()"
                    v-model="selectedTipoContribuinte"
                    :options="tiposContribuinte"
                    optionLabel="name"
                    placeholder="Selecione um Tipo de Contribuinte"
                  />
                </span>
              </div>
            </div>
            <div class="row" v-if="checkPrestador == true">
              <div class="col-md-4 mb-3">
                <label for="cpfCnpj">{{ this.selectedTipoContribuinte.key == 'J' ? 'CNPJ:' : 'CPF:' }}</label>
                <span class="p-fluid">
                  <template v-if="selectedTipoContribuinte.key == 'J'">
                    <InputMask
                      @blur="validarDocumento()"
                      v-model="documento"
                      key="J"
                      id="tipoTomador"
                      mask="**.***.***/****-99"
                      placeholder="CNPJ"
                      style="text-transform: uppercase;"
                    />
                  </template>
                  <template v-else>
                    <InputMask
                      @blur="validarDocumento()"
                      v-model="documento"
                      key="F"
                      id="tipoTomador"
                      mask="999.999.999-99"
                      placeholder="CPF"
                    />
                  </template>
                </span>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-md-2 col-lg-2 mb-3">
              <Button
                class="btn btn-primary"
                type="button"
                icon="pi pi-print"
                label="Imprimir"
                title="Imprimir"
                :disabled="loading"
                @click="imprimirConsultaNotasRecebidas()"
              ></Button>
            </div>
          </div>

          <div style="height: 45vh"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from '../services/acesso/login.service';
import ReportService from '../services/report.service';
import Util from '../Utils/util';

export default {
  name: 'RelatorioNotasRecebidas',

  components: {},
  data() {
    return {
      erros: [],
      loading: null,
      compIni: '',
      compFim: '',
      competenciaLimite: null,
      currentUser: null,
      checkPrestador: false,
      selectedTipoContribuinte: null,
      tiposContribuinte: [
        { name: 'Pessoa Jurídica', key: 'J' },
        { name: 'Pessoa Física', key: 'F' },
      ],
      documento: null,
    };
  },
  mounted() {
    document.getElementById('compIni').focus();
  },
  created() {
    this.selectedTipoContribuinte = this.tiposContribuinte[0];
    this.currentUser = LoginService.currentUserValue;
    this.competenciaLimite = new Date();
    this.competenciaLimite.setMonth(this.competenciaLimite.getMonth());
    this.carregarCompetenciaAtual();
  },
  methods: {
    transformarCompetenciaParaDataInicio(competencia) {
      const [ano, mes] = competencia.split('/').map(Number);
      return `${ano}-${String(mes).padStart(2, '0')}-01`;
    },
    transformarCompetenciaParaDataFim(competencia) {
      const [ano, mes] = competencia.split('/').map(Number);
      const ultimoDia = new Date(ano, mes, 0).getDate();
      return `${ano}-${String(mes).padStart(2, '0')}-${ultimoDia}`;
    },
    carregarCompetenciaAtual() {
      let ano = this.competenciaLimite.getFullYear();
      let mes = this.competenciaLimite.getMonth();
      mes = mes + 1;

      this.compIni = ano + '/' + mes.toString().padStart(2, '0');
      this.compFim = ano + '/' + mes.toString().padStart(2, '0');
    },
    imprimirConsultaNotasRecebidas() {
      var msg = null;
      if (!this.compIni) {
        msg = 'É necessário informar a competência inicial!';
      } else if (!this.compFim) {
        msg = 'É necessário informar a competência final!';
      }
      if (!msg) {
        this.processando(true);
        let compInicial = this.compIni ? this.transformarCompetenciaParaDataInicio(this.compIni) : null;
        let compFinal = this.compFim ? this.transformarCompetenciaParaDataFim(this.compFim) : null;
        this.documento = this.documento != '' ? this.documento : null;
        ReportService.imprimir('ConsultaNotaFiscalRecebidas', [
          {
            param: 'ID_CLIENTE',
            string: this.currentUser.usuario.idCliente,
          },
          {
            param: 'DOC_TOMADOR',
            string: this.currentUser.contribuinte.documento,
          },
          {
            param: 'DOC_PRESTADOR',
            string: this.documento,
          },
          {
            param: 'COMPETENCIA_FINAL_FORMAT',
            string: this.compFim,
          },
          {
            param: 'COMPETENCIA_INICIAL_FORMAT',
            string: this.compIni,
          },
          {
            param: 'COMPETENCIA_FINAL',
            string: compFinal,
          },
          {
            param: 'COMPETENCIA_INICIAL',
            string: compInicial,
          },
        ])
          .then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },
    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documento);

      if (!validar && this.documento) {
        console.log(validar);
        this.$root.$emit('alert:warn', 'CPF/CNPJ inválido!');
      }

      return validar;
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },
  },
  computed: {},
};
</script>

<style scoped></style>
